"use client";
import React, { memo } from "react";
import { Box, BoxProps, CircularProgress } from "@mui/material";
import { AppConstant } from "@/const";
import { useAppSelector } from "@/redux-store";
import { FadeLoader } from "react-spinners";

const AppProgress = ({ id = AppConstant.APP_PROGRESS_ID, sx }: BoxProps) => {
  const isActive = useAppSelector(
    (state) => state.commonReducer.isShowFullMenu
  );
  return (
    <Box
      id={id}
      sx={{
        display: "none",
        alignItems: "center",
        justifyContent: "center",
        position: "fixed",
        zIndex: 999999,
        inset: 0,
        // marginLeft: isActive ? "262px" : "72px",
        ...sx,
      }}
    >
      {/* <CircularProgress /> */}
      <FadeLoader color="#1876f2" className="mx-auto" />
    </Box>
  );
};

export default memo(AppProgress);
